import React, { useState } from "react";
import { AiOutlineUser } from "react-icons/ai";
import { RiMailSendLine } from "react-icons/ri";
import { FaPhoneAlt } from "react-icons/fa";
import { Button } from "flowbite-react";
import { FaArrowRightLong } from "react-icons/fa6";
import location_09 from "../../assets/images/location_09.svg";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import send2 from "../../assets/images/send2.svg";

export default function ModalTH() {
  const [isOpen, setIsOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    address: "",
    message: "",
  });

  // Email validation function
  const validateEmail = (email) => {
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
    return emailRegex.test(email);
  };

  // Phone number validation function
  const validatePhoneNumber = (phoneNumber) => {
    const phoneRegex = /^[0-9]{10,15}$/;
    return phoneRegex.test(phoneNumber);
  };

  // Handle form input changes
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  // Handle form submission
  const handleSubmit = (e) => {
    e.preventDefault();

    // Check if any field is empty
    if (
      !formData.name ||
      !formData.email ||
      !formData.phone ||
      !formData.address ||
      !formData.message
    ) {
      toast.error("Vui lòng điền đầy đủ thông tin!");
      return;
    }

    // Validate email
    if (!validateEmail(formData.email)) {
      toast.error("Email không hợp lệ!");
      return;
    }

    // Validate phone number
    if (!validatePhoneNumber(formData.phone)) {
      toast.error("Số điện thoại không hợp lệ!");
      return;
    }

    setIsLoading(true);

    // Simulate form submission process
    setTimeout(() => {
      setIsLoading(false);
      toast.success("Gửi liên hệ thành công!");

      // Reset form data after submission
      setFormData({
        name: "",
        email: "",
        phone: "",
        address: "",
        message: "",
      });
    }, 2000); // Adjust time delay as necessary
  };

  // Open and close modal handlers
  const openModal = () => setIsOpen(true);
  const closeModal = () => setIsOpen(false);

  return (
    <div className="flex">
      <button onClick={openModal} className="w-full lg:w-[309px] ">
        <div className="w-full h-[54px] rounded-[30px] hover:bg-[#27C6FF] hover:text-white hover:w-full lg:w-full bg-[#1C9BDB] flex items-center justify-center gap-2 text-white">
          <p className="text-[16px] font-normal">Tìm hiểu thêm </p>
          <img src={send2} alt="se" />
        </div>
      </button>

      {/* Modal */}
      {isOpen && (
        <div
          className="fixed inset-0 flex items-center justify-center z-50 bg-black bg-opacity-50"
          onClick={closeModal} // Close modal when clicking outside
        >
          <div
            className="w-full max-w-[90%] sm:max-w-[80%] md:max-w-[60%] lg:max-w-[40%] mx-auto rounded bg-white shadow-custom1 p-6 max-h-[90vh] overflow-y-auto"
            onClick={(e) => e.stopPropagation()} // Prevent modal close when clicking inside content
          >
            <div className="flex flex-col gap-4">
              <div>
                <p className="text-[24px] text-[#033F6A] font-semibold text-center">
                  Hãy nói với chúng tôi
                </p>
              </div>
              <form onSubmit={handleSubmit}>
                <div className="w-full flex flex-col gap-4 md:flex-row">
                  <div className="flex flex-col gap-1 md:w-1/2 lg:w-1/2 w-full">
                    <label className="text-[16px] font-medium text-black">
                      Họ và tên
                    </label>
                    <div className="flex items-center border border-gray-300 rounded-md p-2 md:w-full lg:w-full">
                      <AiOutlineUser className="text-gray-500 mr-2" />
                      <input
                        type="text"
                        name="name"
                        value={formData.name}
                        onChange={handleChange}
                        placeholder="Họ và Tên"
                        className="flex-grow outline-none border-none"
                        required
                      />
                    </div>
                  </div>
                  <div className="flex flex-col gap-1 md:w-1/2 lg:w-1/2 w-full">
                    <label className="text-[16px] font-medium text-black">
                      Địa chỉ email
                    </label>
                    <div className="flex items-center border border-gray-300 rounded-md p-2 md:w-full lg:w-full">
                      <RiMailSendLine className="text-gray-500 mr-2" />
                      <input
                        type="email"
                        name="email"
                        value={formData.email}
                        onChange={handleChange}
                        placeholder="Email của bạn"
                        className="flex-grow outline-none border-none"
                        required
                      />
                    </div>
                  </div>
                </div>
                <div className="flex flex-col gap-4 md:mt-4 lg:mt-4 md:flex-row w-full">
                  <div className="flex flex-col gap-1 md:w-1/2 lg:w-1/2 w-full mt-4">
                    <label className="text-[16px] font-medium text-black">
                      Số điện thoại
                    </label>
                    <div className="flex w-full items-center border border-gray-300 rounded-md p-2 md:w-full lg:w-full">
                      <FaPhoneAlt className="text-gray-500 mr-2" />
                      <input
                        type="text"
                        name="phone"
                        value={formData.phone}
                        onChange={handleChange}
                        placeholder="Số điện thoại của bạn"
                        className="flex-grow outline-none border-none"
                        required
                      />
                    </div>
                  </div>
                  <div className="flex flex-col gap-1 md:w-1/2 lg:w-1/2 w-full md:mt-4">
                    <label className="text-[16px] font-medium text-black">
                      Địa chỉ
                    </label>
                    <div className="flex w-full items-center border border-gray-300 rounded-md p-2 md:w-full lg:w-full">
                      <img
                        src={location_09}
                        alt="location"
                        className="text-gray-500 mr-2"
                      />
                      <input
                        type="text"
                        name="address"
                        value={formData.address}
                        onChange={handleChange}
                        placeholder="Nhập địa chỉ của bạn"
                        className="flex-grow outline-none border-none"
                        required
                      />
                    </div>
                  </div>
                </div>
                <div className="w-full flex flex-col gap-1 md:mt-4 lg:mt-4 mt-4">
                  <label>Sản phẩm</label>
                  <select
                    name="message"
                    value={formData.message}
                    onChange={handleChange}
                    className="text-gray-500 w-full h-[50px] px-[16px] py-[14px] border border-[#E2E2E2] rounded-[16px]"
                    required
                  >
                    <option value="" disabled>
                      Chọn một sản phẩm
                    </option>
                    <option value="Bigmax">Bigmax Academy</option>
                    <option value="BlueRise">BlueRise</option>
                    <option value="Keyavo">Keyavo</option>
                  </select>
                </div>

                <div className="md:flex lg:flex-row-reverse md:items-center flex flex-col md:justify-center mt-3 md:mt-4 gap-4">
                  <button
                    type="submit"
                    className="flex items-center justify-center gap-5 bg-[#27C6FF] hover:bg-green-500 hover:text-white w-full h-[54px] rounded-[30px] md:w-[171px] lg:w-[171px]"
                    disabled={isLoading}
                  >
                    <div className="flex items-center gap-3 text-white">
                      {isLoading ? (
                        <span className="animate-spin h-5 w-5 border-4 border-t-4 border-white border-solid rounded-full" />
                      ) : (
                        <p className="text-[16px] font-normal text-white">
                          Gửi liên hệ
                        </p>
                      )}
                      <FaArrowRightLong />
                    </div>
                  </button>
                  <Button
                    className="px-4 py-2 bg-[#F1F0F0] text-[#CCCCCC] w-full rounded-[30px] h-[54px] lg:w-[171px]"
                    onClick={closeModal}
                  >
                    Đóng lại
                  </Button>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}

      {/* Toast notifications */}
      <ToastContainer position="top-right" />
    </div>
  );
}
